import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// FAQ Data
const helpData = {
  NotificationHelp: [
    {
      question: "What is Notification?",
      answer: `• Notification is used to send notifications, messages, warnings, updates, etc., to wallet holders.

• It also helps users view complaints raised through Mini Statement (Report Issue) or Feedback (when rating is less than 3).

• It contains details like complaint number, order ID, and the timestamp of the complaint.`,
    },
    {
      question: "Where can I locate the Notifications?",
      answer: `You can easily find notifications by identifying the Bell icon placed on the top of the Home/Main page.`,
    },
    {
      question: "How will I know whether my complaint is resolved?",
      answer: `Once the complaint is resolved, a notification will be sent under the Notifications section.`,
    },
  ],
};

const NotificationHelp = ({ selectedSection = "LoadMoney" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Notifications.jpg"
          alt="Profile illustration"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* FAQ Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Notification and help
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default NotificationHelp;
